import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CategorySection } from '../components/CategorySection';
import { Sidebar } from '../components/Sidebar';
import { NewsCategories } from '../components/news/NewsCategories';
import { newsCategories } from '../data/newsData';
export const HomePage = () => {
  return <main className="flex-grow container mx-auto px-4 py-6 lg:px-6" data-id="element-376">
      <div className="mb-8" data-id="element-377">
        <h1 className="text-3xl font-bold mb-2" data-id="element-378">Latest News</h1>
        <p className="text-gray-600" data-id="element-379">
          Stay informed with the latest updates from around the world.
        </p>
      </div>
      <NewsCategories categories={newsCategories} activeCategory="all" data-id="element-380" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-381">
        <div className="lg:col-span-8" data-id="element-382">
          <HeroSection data-id="element-383" />
          <CategorySection title="Politics" category="politics" data-id="element-384" />
          <CategorySection title="Business" category="business" data-id="element-385" />
          <CategorySection title="Technology" category="technology" data-id="element-386" />
        </div>
        <div className="lg:col-span-4" data-id="element-387">
          <Sidebar data-id="element-388" />
        </div>
      </div>
    </main>;
};